<div class="user-container" *ngIf="type === 'user'"
    [ngClass]="{'medium': size === 'medium', 'large': size === 'large', 'very-small': size === 'very-small', 'very-large': size === 'very-large'}">
    <img class="user-image" #img
        [src]="src | imageUrlPipe : size"
        (error)="img.src= 'assets/img/small_imagen.jpg'">
</div>

<div class="course-container" *ngIf="type === 'course'"
    [ngClass]="size">
    <ng-container *ngIf="!loading">
        <ng-container *ngIf="!src?.onlyUrl">
            <img class="course-image" #img *ngIf="!src?.mobile_image" [src]="src?.image && src?.image_url?.includes('curso') ? 'https://d3puay5pkxu9s4.cloudfront.net/curso/' + src.id + '/800_imagen.jpg' : 'https://d3puay5pkxu9s4.cloudfront.net/courses/' + src.id + '/img/web/800_imagen.jpg'"
                (error)="img.src='assets/img/course_default.jpeg'">
            <img class="course-image" #img *ngIf="src?.mobile_image"
                [src]="'https://d3puay5pkxu9s4.cloudfront.net/courses/'+ src.id + '/img/phone/' + src.mobile_image"
                (error)="img.src='assets/img/course_default.jpeg'">
        </ng-container>
        <ng-container *ngIf="src?.onlyUrl">
            <img class="course-image" #img [src]="src?.image_url" (error)="img.src='assets/img/course_default.jpeg'">
        </ng-container>
    </ng-container>
    <div class="skltn skltn-image course-image" *ngIf="loading">
    </div>
</div>

<div class="business-container" *ngIf="type === 'business'" [ngClass]="{'small': size === 'small'}">
    <img class="business-image" *ngIf="src != null && src != ''" #img
        [src]="'https://d3puay5pkxu9s4.cloudfront.net/'+src+'?a=' + randomNumber"
        (error)="img.src='assets/img/medium_imagen.jpg'">
    <img class="business-image" *ngIf="src == null || src == ''"
        src="assets/img/medium_imagen.jpg">
</div>

<div class="category-container" *ngIf="type === 'category'"
    [ngClass]="size">
    <img class="category-image" #img [src]="src | getCategoryLogoPipe : data" [alt]="name">
</div>

<div class="category-container" *ngIf="type === 'home' || type === 'website' || type === 'info'"
    [ngClass]="size">
    <img class="website-image" #img [src]="src | getWebsiteUrl" [alt]="name">
</div>

<div class="route-container" *ngIf="type === 'routes'"
    [ngClass]="{'small': size === 'small', 'medium': size === 'medium', 'large': size === 'large'}">
    <ng-container *ngIf="!loading">
        <ng-container *ngIf="src != null && src != ''">
            <img class="route-image" #img
                [src]="'https://d3puay5pkxu9s4.cloudfront.net/'+src"
                (error)="img.src='assets/img/course_default.jpeg'">
        </ng-container>
        <ng-container *ngIf="src == null || src == ''">
            <div class="route-placeholder" [style.background-color]="routePlaceholderColor">
                <span class="route-placeholder__initials">{{routeInitials}}</span>
            </div>
        </ng-container>
    </ng-container>
    <div class="skltn skltn-image route-image" *ngIf="loading">
    </div>
</div>

<div class="route-container" *ngIf="type === 'route'"
    [ngClass]="{'small': size === 'small', 'medium': size === 'medium', 'large': size === 'large'}">
    <ng-container *ngIf="!loading">
        <img class="route-image" *ngIf="src != null && src != ''" #img
            [src]="'https://d3puay5pkxu9s4.cloudfront.net/'+src.split('.')[0] + '-min.jpg'"
            (error)="img.src='assets/img/course_default.jpeg'">
        <img class="route-image" *ngIf="src == null || src == ''" src="assets/img/course_default.jpeg">
    </ng-container>
    <div class="skltn skltn-image route-image" *ngIf="loading">
    </div>
</div>
